import { darkThemeToClassMap, darkThemeValues, Theme } from '@/constants/theme';
import { IMondayContext } from '@/types/response/monday/context';
import mondaySdk from 'monday-sdk-js';
import React, { createContext, useContext, useEffect, useState } from 'react';

const monday = mondaySdk();

// Define context shape
interface ThemeContextProps {
  isDarkTheme: boolean;
}

// Create context with default value
const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

// Provider Component
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDarkTheme, setDarkTheme] = useState(false);

  useEffect(() => {
    monday.listen('context', (res: { data: IMondayContext}) => {
      const theme = res?.data?.theme as Theme;
      document.documentElement.classList.remove('dark', ...Object.values(darkThemeToClassMap));

      if (darkThemeValues.includes(theme)) {
        document.documentElement.classList.add('dark', darkThemeToClassMap[theme]);
        setDarkTheme(true);
      } else {
        setDarkTheme(false);
      }
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ isDarkTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom Hook to use Theme Context
export const useColorTheme = (): ThemeContextProps => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};